import { render, staticRenderFns } from "./CreateReportnotregis.vue?vue&type=template&id=1696186e&"
import script from "./CreateReportnotregis.vue?vue&type=script&lang=js&"
export * from "./CreateReportnotregis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports